module.exports = __webpack_public_path__ + "static/media/0.beginning.dbf16e0d.mp4";